'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct12 from "./scala.-Product12.js";
var $p;
/** @constructor */
function $c_T12(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12) {
  this.mJ = null;
  this.mN = null;
  this.mO = null;
  this.mP = null;
  this.mQ = null;
  this.mR = null;
  this.mS = null;
  this.mT = null;
  this.mU = null;
  this.mK = null;
  this.mL = null;
  this.mM = null;
  this.mJ = _1;
  this.mN = _2;
  this.mO = _3;
  this.mP = _4;
  this.mQ = _5;
  this.mR = _6;
  this.mS = _7;
  this.mT = _8;
  this.mU = _9;
  this.mK = _10;
  this.mL = _11;
  this.mM = _12;
}
export { $c_T12 as $c_T12 };
$p = $c_T12.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T12;
/** @constructor */
function $h_T12() {
}
export { $h_T12 as $h_T12 };
$h_T12.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 12;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct12.$f_s_Product12__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1964145863), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T12) && ((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mJ, x$0.mJ) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mN, x$0.mN)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mO, x$0.mO)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mP, x$0.mP)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mQ, x$0.mQ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mR, x$0.mR)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mS, x$0.mS)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mT, x$0.mT)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mU, x$0.mU)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mK, x$0.mK)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mL, x$0.mL)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mM, x$0.mM))));
});
$p.o = (function() {
  return "Tuple12";
});
$p.b = (function() {
  return (((((((((((((((((((((((("(" + this.mJ) + ",") + this.mN) + ",") + this.mO) + ",") + this.mP) + ",") + this.mQ) + ",") + this.mR) + ",") + this.mS) + ",") + this.mT) + ",") + this.mU) + ",") + this.mK) + ",") + this.mL) + ",") + this.mM) + ")");
});
function $isArrayOf_T12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eB)));
}
export { $isArrayOf_T12 as $isArrayOf_T12 };
var $d_T12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T12, "scala.Tuple12", ({
  eB: 1,
  b: 1,
  c: 1,
  rK: 1,
  a: 1
}));
export { $d_T12 as $d_T12 };
